require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./enrolments-enrolling-great-start-early-learing-centre.json") })
        }
      }, "path---enrolments-enrolling-great-start-early-learing-centre");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---enrolments-enrolling-great-start-early-learing-centre!./.cache/json/enrolments-enrolling-great-start-early-learing-centre.json
// module id = 1232
// module chunks = 231608221292675